/* Aryellys header icons (styles in ary-candy-header-icons.css).
   1) Keeps the candy jar filled to match the cart: empty when the cart is empty, 2 candies per item, full at 4+.
      When something is added while the jar is off screen (the customer scrolled down a product page),
      the page glides back up first, then the candies drop in and the jar bounces, so people see it fill.
   2) The homepage has its own header; this swaps its plain account/cart icons for Max and the jar,
      with "Account" and "Cart" underneath. The jar drawing is copied from the inner-page header,
      which is also on the homepage (just hidden). */
(function () {
  function fillFor(count) {
    return Math.max(0, Math.min(count * 2, 8));
  }

  function readCount(el) {
    var n = parseInt(String(el && el.textContent || '').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  function bounce(el) {
    el.classList.remove('ary-jar-bounce');
    void el.offsetWidth;
    el.classList.add('ary-jar-bounce');
    setTimeout(function () { el.classList.remove('ary-jar-bounce'); }, 800);
  }

  function setFill(el, count, animate) {
    var fill = String(fillFor(count));
    var before = el.getAttribute('data-fill');
    if (before === fill) return;
    el.setAttribute('data-fill', fill);
    if (animate && before !== null) bounce(el);
  }

  /* ----- inner-page header: cart-icon.ary-jar ----- */
  var lastCount = null;
  var pending = false;

  function jarIcons() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-icon.ary-jar'));
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function anyShownJar() {
    var list = jarIcons().concat(Array.prototype.slice.call(document.querySelectorAll('.ary-real a.ary-cart')));
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return list[i];
    }
    return null;
  }

  function popupOpen() {
    return !!document.querySelector('dialog[open]');
  }

  function applyFill(count, doBounce) {
    var fill = String(fillFor(count));
    jarIcons().forEach(function (icon) {
      icon.setAttribute('data-fill', fill);
      if (doBounce) bounce(icon);
    });
  }

  /* This store scrolls inside a wrapper (.page-wrapper) instead of the whole window,
     so scroll whichever box above the jar is actually scrolled, plus the window just in case. */
  function scrollUp(fromEl, behavior) {
    for (var el = fromEl.parentElement; el && el !== document.documentElement; el = el.parentElement) {
      if (el.scrollTop > 0) {
        try { el.scrollTo({ top: 0, behavior: behavior }); } catch (e) { el.scrollTop = 0; }
      }
    }
    try { window.scrollTo({ top: 0, behavior: behavior }); } catch (e) { window.scrollTo(0, 0); }
  }

  function whenOnScreen(el, done) {
    var start = Date.now();
    (function check() {
      if (onScreen(el) || Date.now() - start > 2500) { done(); return; }
      setTimeout(check, 60);
    })();
  }

  function syncHeaderJars(animate) {
    var icons = jarIcons();
    if (!icons.length || pending) return;
    var count = readCount(icons[0].querySelector('.cart-bubble__text-count'));

    if (lastCount === null || !animate) {
      applyFill(count, false);
      lastCount = count;
      return;
    }

    if (count === lastCount) {
      // keep the level right if the theme redraws the icon
      var fill = String(fillFor(count));
      icons.forEach(function (icon) {
        if (icon.getAttribute('data-fill') !== fill) icon.setAttribute('data-fill', fill);
      });
      return;
    }

    var added = count > lastCount;
    lastCount = count;
    var jar = anyShownJar();

    if (added && jar && !onScreen(jar) && !popupOpen()) {
      // Keep showing the old level, glide up to the header, then drop the new candies in.
      pending = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scrollUp(jar, reduce ? 'auto' : 'smooth');
      whenOnScreen(jar, function () {
        setTimeout(function () {
          pending = false;
          var icons2 = jarIcons();
          var now = icons2.length ? readCount(icons2[0].querySelector('.cart-bubble__text-count')) : count;
          lastCount = now;
          applyFill(now, true);
        }, 150);
      });
      return;
    }

    applyFill(count, true);
  }

  /* Clicking the word "Account" (signed-in customers) opens the account menu like the avatar does. */
  function wireOutsideLabels() {
    document.querySelectorAll('.ary-hdr-label--outside').forEach(function (label) {
      if (label.__aryWired) return;
      label.__aryWired = true;
      label.addEventListener('click', function () {
        var acc = label.parentElement && label.parentElement.querySelector('shopify-account');
        var btn = acc && acc.shadowRoot && acc.shadowRoot.querySelector('button');
        if (btn) btn.click();
      });
    });
  }

  /* ----- homepage header ----- */
  var MAX_IMG = 'https://cdn.shopify.com/s/files/1/0741/7744/6049/files/max-flying-cursor-approved-transparent-v4.png?v=1784729848&width=120';

  function upgradeHomeHeader() {
    var actions = document.querySelector('.ary-real .ary-actions');
    if (!actions || actions.__aryDone) return;
    var jarSource = document.querySelector('.ary-jar__icon .ary-jar__svg');
    var links = actions.querySelectorAll('a');
    var acc = null, cart = null;
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (/\/account/.test(href)) acc = a;
      else if (/\/cart/.test(href)) cart = a;
    });

    if (acc) {
      acc.classList.add('ary-acc');
      acc.setAttribute('aria-label', 'Account');
      acc.innerHTML =
        '<span class="ary-max-avatar"><img src="' + MAX_IMG + '" alt="" width="120" height="132" decoding="async"></span>' +
        '<span class="ary-hdr-label" aria-hidden="true">Account</span>';
    }

    if (cart && jarSource) {
      var countEl = cart.querySelector('b');
      var count = readCount(countEl);
      cart.classList.add('ary-cart');
      cart.setAttribute('aria-label', 'Cart');
      cart.setAttribute('data-count', String(count));
      cart.innerHTML = '';
      cart.appendChild(jarSource.cloneNode(true));
      var badge = document.createElement('b');
      badge.textContent = String(count);
      cart.appendChild(badge);
      var label = document.createElement('span');
      label.className = 'ary-hdr-label';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = 'Cart';
      cart.appendChild(label);
      setFill(cart, count, false);
    }

    actions.__aryDone = true;
  }

  /* Keep the homepage jar in step when items are added without leaving the page. */
  function refreshHomeCart() {
    var cart = document.querySelector('.ary-real .ary-actions a.ary-cart');
    if (!cart || !window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var n = c.item_count || 0;
        cart.setAttribute('data-count', String(n));
        var b = cart.querySelector('b');
        if (b) b.textContent = String(n);
        setFill(cart, n, true);
      })
      .catch(function () {});
  }

  function start() {
    syncHeaderJars(false);
    wireOutsideLabels();
    upgradeHomeHeader();

    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncHeaderJars(true);
        wireOutsideLabels();
      }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener('cart:update', function () {
      setTimeout(function () {
        syncHeaderJars(true);
        refreshHomeCart();
      }, 80);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
